import { useMemo } from 'react';

import { isSameSymbol, isSameSymbolIgnoringPeriod } from '@/entities/symbol';
import type { TabSymbol } from '@/features/Dashboard/form/AppForm/context/types';
import { AppType } from '@/features/Dashboard/types';
import { useForwardCatalog, useSpotCatalog } from '@/features/Catalog/api';

export const SymbolAlias = ({ symbol, type }: { symbol: TabSymbol; type?: AppType }) => {
  const { data: spotData } = useSpotCatalog();
  const { data: fwdData } = useForwardCatalog();
  const data = useMemo(() => {
    if (type === AppType.FWD) return fwdData;
    return spotData;
  }, [fwdData, spotData, type]);

  return useMemo(() => {
    const catalogItem = data?.find(item => {
      if (type === AppType.FWD) return isSameSymbolIgnoringPeriod(item.Symbol, symbol.symbol);
      return isSameSymbol(item.Symbol, symbol.symbol);
    });

    return catalogItem?.Alias || symbol.symbol.Code;
  }, [data, symbol.symbol, type]);
};
